var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg10(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_264_4193)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.8196 56.3343C53.1671 59.9914 48.7058 62.7383 43.7959 64.3532C38.8859 65.9681 33.6651 66.4057 28.5548 65.6307L66.1161 28.0695C66.8911 33.1797 66.4535 38.4006 64.8386 43.3105C63.2236 48.2204 60.4767 52.6818 56.8196 56.3343Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.66575 9.66272C13.4239 5.89859 18.0371 3.09984 23.1115 1.50545C28.1859 -0.0889502 33.5709 -0.431636 38.8065 0.506647L0.512732 38.8065C-0.426453 33.5706 -0.0845091 28.1853 1.50937 23.1103C3.10324 18.0353 5.90169 13.4214 9.66575 9.66272Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8181 9.66267C58.6203 11.4658 60.2097 13.4698 61.5548 15.6355L16.1193 61.0709C11.9869 58.5078 8.46672 55.0699 5.80655 50.9993L51.4709 5.31659C53.3996 6.57538 55.1917 8.03196 56.8181 9.66267Z",
    fill: "#18EAEA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_264_4193"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 66,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg10);
export default __webpack_public_path__ + "static/media/10.6debf4c2fa141141317019001328d74b.svg";
export { ForwardRef as ReactComponent };